/** @module Enums */ /** typedoc */

export enum ServiceOffersKindEnum {

    /**
     * User use Legacy Billing for the service offer
     */
    Legacy = 'Legacy',


    /**
     * User use Fusebill Billing for the service offer
     */
    Fusebill = 'Fusebill',
}
